<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>Contents</h1>
<p class="tocfmf"><a class="xref" href="#/chikoning0006#pref">Preface</a></p>
<p class="tocf"><a class="xref" href="#/chikoning0007#intro">Introduction: Sun Turtles and Superstorms</a></p>
<p class="toc"><a class="xref" href="#/chikoning0009#ch01"><b>1</b>  At the Water’s Edge: From the Aquatic Zone to the Emergent Marsh</a></p>
<p class="toc"><a class="xref" href="#/chikoning0011#ch02"><b>2</b>  Wet Meadows: Not Too Dry, Not Too Wet</a></p>
<p class="toc"><a class="xref" href="#/chikoning0013#ch03"><b>3</b>  Pond-Meadow-Forest, Repeat: The Beaver’s Tale</a></p>
<p class="toc"><a class="xref" href="#/chikoning0015#ch04"><b>4</b>  Stuck in the Muck: Bogs and Fens</a></p>
<p class="toc"><a class="xref" href="#/chikoning0017#ch05"><b>5</b>  Wooded Wetlands: Basin Castles and Big-River Swamps</a></p>
<p class="toc"><a class="xref" href="#/chikoning0019#ch06"><b>6</b>  Vernal Pools: Believing in Wetlands That Aren’t Always There</a></p>
<p class="toc"><a class="xref" href="#/chikoning0021#ch07"><b>7</b>  Salt Marshes: A Disappearing Act</a></p>
<p class="toc"><a class="xref" href="#/chikoning0022#ch08"><b>8</b>  Wetland Restoration: Changing Techniques, Changing Goals, Changing Climate</a></p>
<p class="toc"><a class="xref" href="#/chikoning0023#ch09"><b>9</b>  Beauty, Ethics, and Inspiration</a></p>
<p class="tocbmf"><a class="xref" href="#/chikoning0024#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chikoning0025#refs">References</a></p>
<p class="tocbm"><a class="xref" href="#/chikoning0026#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-koning-0005.vue?6433d2a4